import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Scenario from './Scenario';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${theme.spacing(2)}px`,
    padding: theme.spacing(4),
    justifyContent: 'space-evenly',
  },
});

const Scenarios = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();
  const scenariosCollection = pageContentResource.attr('scenarios');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {scenariosCollection.resources().list().map((scenarioResource) => {
        return (
          <Scenario
            key={scenarioResource.id()}
            scenarioResource={scenarioResource}
          />
        );
      })}
    </Box>
  );
};

Scenarios.defaultProps = {
  className: '',
};

Scenarios.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Scenarios);
